import styled from 'styled-components';
import { visuallyHiddenCss } from '@chegg-ui/theme';
export var HiddenHeaderWrapper = styled.span.withConfig({
  componentId: "sc-1ife7qo-0"
})(["", ""], visuallyHiddenCss);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/HiddenHeader/styled.js
// module id = 4567
// module chunks = 11